<template>
    <popup-modal ref="popup" id="actionModal" :class="windowClass">
        <h3 v-if="title" class="window-title" :style="'text-align:' + titlePosition">
            <span class="window-title__text">{{ title }}</span>
            <button class="closeModalButton" @click="cancelClick" aria-label="Закрыть" title="Закрыть">
                <img src="../assets/icons/close.svg" alt="close" />
            </button>
        </h3>
        <div class="content" :class="contentClass">
            <slot name="html-content" v-if="$slots['html-content'] || htmlContent">
                <div v-html="htmlContent"></div>
            </slot>
            <slot name="content" v-else>{{ content }}</slot>
        </div>
        <div class="btns stack" :class="{'inline-buttons': inlineButtons, 'small-buttons': smallButtons, 'text-left': btnTextLeft}">
            <button v-for="(btn, index) in buttons"
                :key="index"
                :class="btn.class"
                :disabled="btn.disabled === true"
                @click="btnClick(btn)">{{ btn.text }}
            </button>
          <button v-if="cancelButton" @click="cancelClick">{{ cancelButton }}</button>  
        </div>
    </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue'

export default {
    name: 'ActionDialogue',
    props: {
        theme: {
            type: String,
            default: 'dark'
        },
        fixedContent: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: ''
        },
        inlineButtons: {
            type: Boolean,
            default: false
        },
        smallButtons: {
            type: Boolean,
            default: false
        }
    },
    components: { PopupModal },

    computed: {
        contentClass() {
            return {
                [`bc${this.buttons.length}`]: true,
                'fixed-content': this.fixedContent
            };
        },
        windowClass() {
            let cls = '';
            if (this.theme && this.theme.length) cls += `${this.theme} `;
            if (this.size && this.size.length) cls += `${this.size} `;
            return cls;
        }
    },

    data: () => ({
        // Parameters that change depending on the type of dialogue
        title: undefined,
        titlePosition: 'left',
        content: undefined,
        htmlContent: undefined,
        focusElement: undefined,
        buttons: [],
        btnTextLeft: false,
        cancelButton: 'Отмена',
        isOpen: false,
        // Private variables
        resolvePromise: undefined,
        rejectPromise: undefined,
        focusElementId: null,
    }),

    methods: {
        close() {
            this.cancelClick();
        },
        show(opts = {}) {
            // Инициализация данных
            if (opts.titlePosition && opts.titlePosition != '') {
                this.titlePosition = opts.titlePosition;
            }
            this.title = opts.title || '';
            this.content = opts.content || '';
            this.htmlContent = opts.htmlContent;
            this.buttons = opts.buttons || [];
            this.btnTextLeft = opts.btnTextLeft == true;
            this.cancelButton = opts.cancelButton;
            this.focusElementId = opts.focusedElement || null;
            // Once we set our config, we tell the popup modal to open
            
            this.isOpen = true;
            this.$refs.popup.open();

            this.initListeners();

            // Автофокус
            if (this.focusElementId) {
                this.$nextTick(() => {
                    setTimeout(() => this.applyFocus(), 100); // Небольшая задержка для завершения анимации модалки
                });
            }

            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            });
        },

        // onHashChange() {
        //     if (!this.isOpen) return;
        //     window.history.pushState('forward', null, '');
        //     // this.cancelClick();
        //     var el = document.getElementById("closeModalButton");
        //     if (el) el.click();
        // },

        onHashChange() {
            if (!this.isOpen) return;
            if (location.hash !== '#modal') this.cancelClick();
        },

        applyFocus() {
            const el = document.getElementById(this.focusElementId);
            if (el) {
                el.focus();
                if (el.select) el.select();
            }
        },

        btnClick(btn) {
            this.$emit('btnClick', btn);
            this.closeModal();
            this.resolvePromise(btn);
        },

        cancelClick() {
            this.closeModal();
            this.resolvePromise(false)
            // Or you can throw an error
            // this.rejectPromise(new Error('User canceled the dialogue'))
        },

        closeModal() {
            // if (!this.isOpen) return;
            if (location.hash === '#modal') {
                this.$router.push({ path: window.location.pathname + window.location.search, replace: true });
            }
            this.isOpen = false;
            this.destroyListeners();
            this.$refs.popup.close();
            this.$emit('close');
            if (location.hash === '#modal') {
                this.$router.back();
            }
        },

        // handleClick(e) {
        //     if (this.isOpen && e.target === this.$refs.popup.$el) {
        //         this.cancelClick();
        //     }
        // },

        handleOutsideClick(e) {
            // Если кликнули по подложке (нативном элементе popup-modal)
            if (e.target.id === 'actionModal') {
                this.cancelClick();
            }
        },

        handleKeyDown(event) {
            if (this.isOpen && event.key === 'Escape') { 
                this.cancelClick();
            }
        },

        initListeners() {
            location.hash = '#modal';
            setTimeout(() => window.addEventListener('popstate', this.onHashChange), 100);
            document.addEventListener('keydown', this.handleKeyDown);
            // document.addEventListener('mousedown', this.handleClick);
            document.addEventListener('mousedown', this.handleOutsideClick);
        },

        destroyListeners() {
            window.removeEventListener('popstate', this.onHashChange);
            document.removeEventListener('keydown', this.handleKeyDown);
            // document.removeEventListener('mousedown', this.handleClick, false);
            document.removeEventListener('mousedown', this.handleOutsideClick);
        }
    },
    beforeDestroy() {
        this.destroyListeners();
    }
}
</script>

<style lang="css" scoped src='../assets/css/ActionDialogue.css'>
</style>